import { render, staticRenderFns } from "./dynamicsdataselector.vue?vue&type=template&id=416df03c"
import script from "./dynamicsdataselector.vue?vue&type=script&lang=js"
export * from "./dynamicsdataselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports